import { isUserProfileComplete } from './userProfileComplete';

let ensureHandler = null;

export function registerProfileCompleteHandler(fn) {
  ensureHandler = fn;
}

/**
 * Resolves with updated user when profile is complete.
 * Opens CompleteProfileModal when incomplete (if provider is mounted).
 */
export async function ensureUserProfileComplete(user) {
  if (isUserProfileComplete(user)) return user;
  if (typeof ensureHandler !== 'function') return user;
  return ensureHandler(user);
}
